import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const paginationDefaultVariants = {
  "size": "md",
  "selected": false
}
const paginationCompoundVariants = [
  {
    "size": "md",
    "selected": true,
    "css": {
      "item": {
        "fontFamily": "default",
        "fontSize": "14",
        "lineHeight": "24",
        "fontWeight": "button.default"
      }
    }
  },
  {
    "size": "sm",
    "selected": true,
    "css": {
      "item": {
        "fontFamily": "default",
        "fontSize": "13",
        "lineHeight": "22",
        "fontWeight": "medium"
      }
    }
  }
]

const paginationSlotNames = [
  [
    "root",
    "pagination__root"
  ],
  [
    "item",
    "pagination__item"
  ],
  [
    "ellipsis",
    "pagination__ellipsis"
  ],
  [
    "trigger",
    "pagination__trigger"
  ]
]
const paginationSlotFns = /* @__PURE__ */ paginationSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, paginationDefaultVariants, getSlotCompoundVariant(paginationCompoundVariants, slotName))])

const paginationFn = memo((props = {}) => {
  return Object.fromEntries(paginationSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const paginationVariantKeys = [
  "size",
  "selected"
]
const getVariantProps = (variants) => ({ ...paginationDefaultVariants, ...compact(variants) })

export const pagination = /* @__PURE__ */ Object.assign(paginationFn, {
  __recipe__: false,
  __name__: 'pagination',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: paginationVariantKeys,
  variantMap: {
  "size": [
    "md",
    "sm"
  ],
  "selected": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, paginationVariantKeys)
  },
  getVariantProps
})